<template>
  <div class="myGoogleMap">
    <DateModal
      modalID="issue_map"
      :fetchData="fetchMarkers"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>
    <b-card-header style="">
      <b> User: </b>
      <b-form-select
        v-model="selected"
        :options="options"
        style="width:170px"
        value-field="item"
        @change="fetchMarkers()"
        text-field="name"
      ></b-form-select>
      <HeaderControl
        :showDateIcon="true"
        @emit-date="modalDateEvent('issue_map')"
      ></HeaderControl>
      <span
        style="float:right; line-height:30px; margin-right:20px; color:rgb(32, 168, 216)"
      >
        {{ from() ? from() : dateFrom }}
        <b>|</b>
        {{ to() ? to() : dateTo }}
      </span>
    </b-card-header>
    <LoadingCard v-if="loading"></LoadingCard>
    <gmap-map
      v-if="!loading"
      :center="center"
      :options="mapOptions"
      style="width:100%;  height: 90vh;"
    >
      <gmap-info-window
        class="mapWindow"
        :options="infoOptions"
        :position="infoPosition"
        :opened="infoOpened"
        @closeclick="infoOpened = false"
      >
        <div :key="key" v-for="(item, key) in cityNum">
          <h4>{{ item.data[0].user }}</h4>
          <br />
          <span>Date: {{ item.data[0].date }}</span>
          <br />
          <span>City: {{ item.data[0].city }}</span>
          <br />
          <hr />
          <span>{{ item.data[0].issue }}</span>
          <hr />
          <b-form-textarea
            id="textarea"
            v-model="solved"
            placeholder="Solve comment"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-button
            variant="outline-primary"
            @click="sendSolved(item.data[0].id)"
            style="display:block; margin:auto;  margin-top:10px; height:40px; width:130px"
            >Submit</b-button
          >
        </div>
      </gmap-info-window>
      <GmapMarker
        v-for="(m, index) in table"
        :key="index"
        :ref="`marker${index}`"
        :position="getPosition(m)"
        @click="toggleInfo(m, index)"
        :icon="
          m[6]
            ? $trackerBase + '/oem-portal/img/' + m[6] + 'dot.png'
            : $trackerBase + '/oem-portal/img/mapgmarker.png'
        "
      />
    </gmap-map>
  </div>
</template>

<script>
import router from "../../../router";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import Datepicker from "vuejs-datepicker";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import DateModal from "../../../components/shared/DateModal.vue";
import HeaderControl from "../../../components/shared/HeaderControl.vue";

export default {
  name: "IssueMap",
  components: {
    router,
    GmapCustomMarker,
    Datepicker,
    LoadingCard,
    DateModal,
    HeaderControl
  },
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      loading: true,
      mapOptions: {
        zoom: 5,
        streetViewControl: false,
        mapTypeControl: false
      },
      center: { lat: 41.881832, lng: -87.6254 },
      table: [],
      stateDateFrom: "",
      markerOptions: {
        url: "https://www.fibernode.com/oem-portal/img/mapgmarker.png",
        size: { width: 20, height: 20, f: "px", b: "px" },
        scaledSize: { width: 20, height: 20, f: "px", b: "px" }
      },
      selected: "All",
      options: [],
      stateDateTo: "",
      cityNum: null,
      solved: "",
      thisLat: null,
      modalDate: false,
      thisLng: null,
      infoPosition: null,
      infoCty: null,
      infoMny: null,
      infoCompany: null,
      infoPicture: null,
      infoOpened: false,
      infoQty: null,
      infoCurrentKey: null,
      dateFrom: "",
      dateTo: "",
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  mounted() {
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.stateDateFrom = fromDate.toJSON().slice(0, 10);
    this.stateDateTo = new Date().toJSON().slice(0, 10);
    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchSalesReps();
    this.fetchMarkers();
  },
  // iz nekog razloga pri lokaciji moram dodati %282%29 da bi ucitalo, nisam siguran sto?
  methods: {
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    modalDateEvent(modal_id) {
      this.$bvModal.show(modal_id);
    },
    fetchSalesReps() {
      this.$http.get("api/arris/sales/salesRepList.php").then(
        res => {
          this.options = res.data;
        },
        err => {
          console.log(err);
        }
      );
    },
    sendSolved(id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("solved", this.solved);
      this.$http
        .post("api/arris/issues/solvedIssue.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          () => {
            this.fetchMarkers();
          },
          err => {
            console.log(err);
          }
        );
    },
    openData(loc, city, lat, lng) {
      router.push(
        "/base/city/?loc=" +
          loc +
          "&city=" +
          city +
          "&lat=" +
          lat +
          "&lng=" +
          lng
      );
    },
    fetchMarkers() {
      this.loadingState = true;
      let params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        user: this.selected
      };
      this.$http
        .get("api/arris/issues/IssueMapPreview.php", {
          params
        })
        .then(
          res => {
            this.table = res.data.records;
            this.loading = false;
          },
          err => {
            console.log(err);
            this.loading = false;
          }
        );
    },
    getPosition: function(marker) {
      return {
        lat: parseFloat(marker[3]),
        lng: parseFloat(marker[4])
      };
    },

    toggleInfo: function(marker, key) {
      var result = { city: [] };
      var jsonObj;

      this.table.forEach(value => {
        if (marker[3] == value[3] && marker[4] == marker[4]) {
          jsonObj = {
            data: [
              {
                user: value[0],
                date: value[1],
                city: value[2],
                issue: value[5],
                id: value[7]
              }
            ]
          };
          result.city.push(jsonObj);
        }
      });
      this.infoPosition = this.getPosition(marker);
      this.infoCty = marker[0];
      this.cityNum = result.city;
      this.infoQty = marker[2];
      this.infoMny = marker[3];
      this.thisLat = marker[4];
      this.thisLng = marker[5];

      if (this.infoCurrentKey === key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
      return this.dateFrom;
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
      return this.dateTo;
    }
  }
};
</script>
<style scoped>
.myGoogleMap {
  margin-top: -17px !important;
  margin-right: -30px;
  margin-left: -30px;
}
</style>
<style>
.gm-style .gm-style-iw-d {
  color: black !important;
}
.gm-style .gm-style-iw-d span {
  font-size: 1.1em;
}
.gm-style .gm-style-iw-d b {
  font-size: 1.1em;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.vdp-datepicker .input-group input {
  background: #515b65 !important;
}
</style>
